import { Autocomplete, Box, InputLabel, TextField } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import timezones from '../../Data/timezones.json';
import { BaseInputProps } from './GetFormInput';

export function FormSelect<T extends FieldValues>({
    control,
    fullWidth,
    helperText,
    label,
    required,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onBlur, onChange, ref, value }, fieldState: { error } }) => (
                <Box>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <Autocomplete
                        onBlur={onBlur}
                        onChange={(event, value) => onChange(value)}
                        options={timezones}
                        ref={ref}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                error={error?.message ? true : false}
                                helperText={error?.message ?? helperText}
                                required={required}
                                variant="outlined"
                            />
                        )}
                        sx={{ maxWidth: fullWidth ? undefined : 350 }}
                        value={value || null}
                    />
                </Box>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
            }}
        />
    );
}
